<template>
  <div class="tool-express">
    <div class="query-form">
      <el-form
        class="dataForm"
        :model="dataForm"
        label-position="left"
        label-width="0"
        :rules="rules"
        @keyup.enter="searchForm"
        @submit.prevent
        ref="dataForm"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item prop="expressNumber">
              <el-input
                v-model="dataForm.expressNumber"
                placeholder="请输入快递单号"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item prop="phone">
              <el-input
                v-model="dataForm.phone"
                placeholder="请输入手机号"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item prop="com">
              <el-select
                v-model="dataForm.com"
                placeholder="请选择快递公司"
              >
                <el-option label="顺丰速运" value="sf" />
                <el-option label="EMS" value="ems" />
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
      <el-button
        type="primary"
        :loading="loading"
        @click="searchForm"
      >
        <template #icon>
          <el-icon><Search /></el-icon>
        </template>
        查询
      </el-button>
    </div>
    <div v-if="popup.show" v-loading="loading" class="query-result">
      <div class="close" @click="close">
        <el-icon><CircleCloseFilled /></el-icon>
      </div>
      <div class="result">
        <div class="hd">
          <div class="left">
            快递公司：{{ popup.result.comDesc }}
            <span class="tag">{{ popup.result.data && !!popup.result.data.length ? popup.result.data[0].status : '' }}</span>
          </div>
          <div class="right">
            运单编号：{{ popup.result.nu }}
          </div>
        </div>
        <div class="detail">
          <div
            class="row"
            v-for="(item, index) in popup.result.data"
            :key="index"
          >
            <div class="dot"></div>
            <div class="state">
              <b>{{ item.status }}</b>
              <span>{{ item.ftime }}</span>
            </div>
            <div class="info">{{ item.context }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tool-express', // 快递查询
  props: {

  },

  data() {
    return {
      dataForm: {},
      rules: {
        expressNumber: [
          { required: true, message: '请输入快递单号', trigger: 'blur' }
        ]
      },
      loading: false,
      popup: {
        show: false,
        result: {}
      }
    }
  },

  watch: {

  },

  computed: {
    
  },

  mounted() {

  },

  methods: {
    searchForm() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$get('/oms/client/workbench/expressQuery', this.dataForm).then(({ data }) => {
            if (data && data.code === 'C0000' && data.result) {
              if (data.result === '需要手机号') {
                this.$prompt('', '请输入手机号', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  inputPlaceholder: '请输入手机号',
                  inputPattern: /^1[0-9]{10}$/,
                  inputErrorMessage: '手机号格式不正确'
                }).then(({ value }) => {
                  let params = Object.assign({ phone: value }, this.dataForm)
                  this.$get('/oms/client/workbench/expressQuery', params).then(({ data }) => {
                    if (data && data.code === 'C0000' && data.result) {
                      this.popup = {
                        show: true,
                        result: JSON.parse(data.result).lastResult
                      }
                    }
                  })
                }).catch(() => {})
              } else {
                this.popup = {
                  show: true,
                  result: JSON.parse(data.result).lastResult
                }
              }
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },

    close() {
      this.popup = {
        show: false,
        result: {}
      }
    }
  }
}
</script>

<style lang="scss">
.tool-express {
  position: relative;
  .query-form {
    height: 0.54rem;
    padding: 0.04rem;
    border: 1px solid #e5e5e5;
    border-radius: 0.08rem;
    background: linear-gradient(#fff, #f3f3f3);
    > .el-form {
      display: inline-block;
      width: calc(100% - 0.8rem);
      vertical-align: top;
      .el-row .el-col {
        position: relative;
        & + .el-col:not(.no-line)::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0.075rem;
          z-index: 2;
          width: 1px;
          height: 0.3rem;
          background: #ccc;
        }
      }
      .el-form-item {
        margin-bottom: 0;
        .el-form-item__error {
          margin-top: 0.04rem;
        }
      }
      .el-input {
        .el-input__wrapper {
          box-shadow: none !important;
          background: none !important;
          .el-input__inner {
            height: 0.42rem;
            line-height: 0.42rem;
          }
        }
      }
    }
    > .el-button {
      width: 0.8rem;
      height: 0.44rem;
      min-width: auto;
      padding: 0;
      border-radius: 0.08rem;
      vertical-align: top;
    }
  }
  .query-result {
    position: absolute;
    left: 0;
    top: 0.54rem;
    z-index: 99;
    width: 100%;
    height: 2.5rem;
    box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0.08rem;
    background: #fff;
    .close {
      position: absolute;
      top: 0.12rem;
      right: 0.15rem;
      z-index: 2;
      width: 19px;
      height: 19px;
      color: #b2b2b2;
      cursor: pointer;
      .el-icon {
        font-size: 19px;
      }
      &:hover {
        color: #0a7cff;
      }
    }
    .result {
      height: 100%;
      padding: 0.15rem 0;
      .no-data {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        text-align: center;
        color: #999;
      }
      .hd {
        display: flex;
        justify-content: space-between;
        padding: 0 0.18rem;
        line-height: 0.24rem;
        .tag {
          display: inline-block;
          height: 0.24rem;
          margin-left: 0.04rem;
          padding: 0 0.06rem;
          border-radius: 0.08rem;
          color: #fff;
          background: #0ab2a8;
        }
        .right {
          margin-right: 0.5rem;
        }
      }
      .detail {
        width: calc(100% - 0.18rem);
        height: calc(100% - 0.39rem);
        margin-top: 0.15rem;
        padding: 0 0 0 0.25rem;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 6px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 3px;
          background: #d0d0d0;
        }
        &::-webkit-scrollbar-track {
          background: #fff;
        }
        .row {
          position: relative;
          padding: 0 0 0.16rem 0.25rem;
          border-left: 1px dashed #cdcdcd;
          &:first-child {
            .dot {
              border-color: #157fff;
              &::after {
                content: '';
                position: absolute;
                top: 2px;
                left: 2px;
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background: #157fff;
              }
            }
            .state {
              b {
                color: #157fff;
              }
              span {
                color: #157fff;
              }
            }
            .info {
              color: #000;
            }
          }
          &:last-child {
            padding-bottom: 0;
          }
          .dot {
            position: absolute;
            top: 4px;
            left: -7px;
            width: 14px;
            height: 14px;
            border: 2px solid #aaa;
            border-radius: 50%;
            background: #fff;
          }
          .state {
            b {
              font-size: 15px;
              font-weight: normal;
            }
            span {
              margin-left: 0.2rem;
              color: #545454;
            }
          }
          .info {
            margin-top: 0.04rem;
            font-size: 12px;
            line-height: 20px;
            color: #545454;
          }
        }
      }
    }
  }
}
</style>
